// extracted by mini-css-extract-plugin
export default {"root":"XJ32Eebd","title":"ltx0dpAz","info":"fJna6ni0","link":"_0xgucYPz"};